import React from "react";
import styled from "styled-components";

const Circle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-color: #22c55e;
  flex-shrink: 0;
`;

const GreenCheck: React.FC = () => (
  <Circle aria-hidden="true">
    <svg width="13" height="10" viewBox="0 0 13 10" fill="none">
      <path
        d="M1 5L4.5 8.5L12 1"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Circle>
);

export default GreenCheck;
